import { ApprovalWorkflowSettings } from '@/features/approval-workflow/components/approval-workflow-settings';
import { MarcoDeMiEmpresa } from '../components/marco-de-mi-empresa';

/**
 * Mi empresa › Aprobaciones (maqueta de Melanie, 25-oct): cuándo una cotización
 * necesita aprobación y quién la firma. Es la pantalla de reglas de siempre,
 * con el modo arriba, los tres pasos y una tarjeta por regla.
 */
export function AprobacionesSection() {
  return (
    <MarcoDeMiEmpresa seccion="aprobaciones">
      <ApprovalWorkflowSettings />
    </MarcoDeMiEmpresa>
  );
}
